<app-header></app-header>
<div class="contentArea">
	<div class="workingArea">
		<router-outlet> </router-outlet>
	</div>
	<app-menue></app-menue>
</div>